import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=a1bc2304&"
import script from "./CardList.vue?vue&type=script&lang=javascript&"
export * from "./CardList.vue?vue&type=script&lang=javascript&"
import style0 from "./CardList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports